// extracted by mini-css-extract-plugin
export default {"root":"MorePageMenu_root__rIn2A","root__icon":"MorePageMenu_root__icon__OPZEJ","root__item_disabled":"MorePageMenu_root__item_disabled__SrPfT"};